"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var Observable_1 = require("rxjs/Observable");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var operators_1 = require("rxjs/operators");
var overview_config_item_model_1 = require("../../../../common/model/overview-config-item.model");
var config_constants_1 = require("../../../../common/constants/config-constants");
var overview_field_type_1 = require("../../../../common/model/overview-field-type");
var overview_card_type_1 = require("../../../../common/model/overview-card-type");
var overview_custom_calculation_fields_service_1 = require("../../../../../../shared/services/api/summary-pages/custom-calculation/overview-custom-calculation-fields.service");
var overview_content_field_model_1 = require("../../../../common/model/overview-content-field.model");
var summary_page_configs_helper_service_1 = require("../../../../common/service/summary-page-configs-helper.service");
/**
 * Dialog for configuring overview card.
 */
var OverviewConfigDialogComponent = /** @class */ (function () {
    function OverviewConfigDialogComponent(summaryPageConfigsHelperService, dialogRef, sessionDataProvider, kbService, dialog, overviewCustomCalculationFieldsService, data) {
        this.summaryPageConfigsHelperService = summaryPageConfigsHelperService;
        this.dialogRef = dialogRef;
        this.sessionDataProvider = sessionDataProvider;
        this.kbService = kbService;
        this.dialog = dialog;
        this.overviewCustomCalculationFieldsService = overviewCustomCalculationFieldsService;
        this.data = data;
        /**
         * @property cardTypes "Card Type - Message Key" mapping.
         */
        this.cardTypes = config_constants_1.OVERVIEW_CARD_TYPES;
        /**
         * @property acceptableOverviewFieldTypes Field types filtered by current card type.
         */
        this.acceptableOverviewFieldTypes = [];
        this.OverviewCardType = overview_card_type_1.OverviewCardType;
        this.OverviewPortfolioFieldType = overview_field_type_1.OverviewPortfolioFieldType;
        // card title and type are required
        this.isValidTitle = true;
        this.isValidType = true;
        this.isCardCreate = false;
        this._mainCategoryChange$ = new ReplaySubject_1.ReplaySubject(1);
        this.itemConfig = data.itemConfig;
        this.rootCategory = data.rootCategory;
    }
    OverviewConfigDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initMainConfigs();
        if (this.itemConfig.id) {
            this.cardTypeViewMessage = this.itemConfig.cardType &&
                this.cardTypes.find(function (cardType) { return cardType.id === _this.itemConfig.cardType.id; }).messageKey;
            this.onCardEdit();
        }
        else {
            this.isCardCreate = true;
            this.onCardCreate();
        }
        this.changeAcceptableOverviewFieldTypes();
        this.eliminateWrongTypeSelection();
    };
    OverviewConfigDialogComponent.prototype.initMainConfigs = function () {
        var _this = this;
        this.currentLanguage$ = this.sessionDataProvider.getCurrentLanguage().pipe(operators_1.publishReplay(1), operators_1.refCount());
        this.entityCategoriesList$ = this.kbService.getMainEntityMetaCategories()
            .pipe(operators_1.map(function (metaCategories) { return Array.from(metaCategories); }), operators_1.switchMap(function (metaCategories) {
            var filteredMetaCategories$ = [];
            metaCategories.forEach(function (metaCategory) {
                filteredMetaCategories$.push(_this.kbService.getMetaFields(metaCategory.getSystemName()).pipe(operators_1.map(function (fields) { return fields.filter(function (field) { return field.getCompoundCategorySystemName() === _this.rootCategory; }); }), operators_1.map(function (filteredFields) { return filteredFields.length ? metaCategory : null; })));
            });
            return filteredMetaCategories$.length ? Observable_1.Observable.zip.apply(Observable_1.Observable, filteredMetaCategories$).pipe(operators_1.map(function (categories) { return categories.filter(function (category) { return !!category; }); })) : [];
        }));
        this.overviewCustomFields$ = this.constructOverviewCustomFields();
        this.viewFormsList$ = this.constructLoadingFormsByType(idm_dynamic_layout_interpreter_1.FormType.VIEW);
        this.editFormsList$ = this.constructLoadingFormsByType(idm_dynamic_layout_interpreter_1.FormType.EDIT);
        this.entityFieldsList$ = this.constructEntityFields();
        this.setOverviewItemTypesByCardType();
    };
    OverviewConfigDialogComponent.prototype.onCardCreate = function () {
        this.changeCardType(overview_card_type_1.OverviewCardType.MAIN_CARD);
    };
    OverviewConfigDialogComponent.prototype.onCardEdit = function () {
        var _this = this;
        this.itemConfig.cardType = this.cardTypes.find(function (item) { return item.id === _this.itemConfig.cardType.id; });
        this.onCardMainCategoryChange(this.itemConfig.itemCategoryName);
    };
    OverviewConfigDialogComponent.prototype.constructOverviewCustomFields = function () {
        var _this = this;
        return this._mainCategoryChange$.pipe(operators_1.switchMap(function (categoryName) {
            return _this.overviewCustomCalculationFieldsService ?
                _this.overviewCustomCalculationFieldsService.getCustomFields(categoryName, _this.itemConfig.cardType.id)
                : Observable_1.Observable.of([]);
        }));
    };
    OverviewConfigDialogComponent.prototype.constructLoadingFormsByType = function (formType) {
        var _this = this;
        return this._mainCategoryChange$.pipe(operators_1.switchMap(function (categoryName) {
            return _this.summaryPageConfigsHelperService.getFormsOfCategory(categoryName, formType)
                .pipe(operators_1.map(function (forms) {
                if (formType === idm_dynamic_layout_interpreter_1.FormType.EDIT && _this.itemConfig.editForm) {
                    _this.itemConfig.editForm = forms.find(function (form) { return form.id === _this.itemConfig.editForm.id; });
                }
                else if (formType === idm_dynamic_layout_interpreter_1.FormType.VIEW && _this.itemConfig.form) {
                    _this.itemConfig.form = forms.find(function (form) { return form.id === _this.itemConfig.form.id; });
                }
                return forms;
            }));
        }), operators_1.shareReplay(1));
    };
    OverviewConfigDialogComponent.prototype.constructEntityFields = function () {
        var _this = this;
        return this._mainCategoryChange$
            .pipe(operators_1.switchMap(function (categoryName) {
            return _this.summaryPageConfigsHelperService.getFieldsByEntity(categoryName);
        }), operators_1.shareReplay(1));
    };
    OverviewConfigDialogComponent.prototype.setOverviewItemTypesByCardType = function () {
        var _this = this;
        this.itemConfig.contentFieldsWithLevels.forEach(function (levelFields) {
            return levelFields.data.forEach(function (dataField) {
                if (!dataField.overviewPortfolioFieldType) {
                    dataField.overviewPortfolioFieldType = _this.itemConfig.cardType.id === overview_card_type_1.OverviewCardType.CUSTOM_CARD
                        || _this.itemConfig.cardType.id === overview_card_type_1.OverviewCardType.GROUP_CARD ? overview_field_type_1.OverviewPortfolioFieldType.CALCULATION
                        : overview_field_type_1.OverviewPortfolioFieldType.FIELD;
                }
            });
        });
    };
    /**
     * Function sets lines on category changes.
     * Applies to {@link OverviewCardType.SINGLE_ENTITY_CARD} and {@link OverviewCardType.GROUP_CARD}
     * @param metaCategoryName name of new selected category
     */
    OverviewConfigDialogComponent.prototype.onCardMainCategoryChange = function (metaCategoryName) {
        this._mainCategoryChange$.next(metaCategoryName);
        if (metaCategoryName !== this.itemConfig.itemCategoryName) {
            this.itemConfig.itemCategoryName = metaCategoryName;
            var dummyConfig = void 0;
            // set default dimensions
            if (this.itemConfig.cardType && (this.itemConfig.cardType.id === overview_card_type_1.OverviewCardType.MAIN_CARD
                || this.itemConfig.cardType.id === overview_card_type_1.OverviewCardType.SINGLE_ENTITY_CARD)) {
                dummyConfig = new overview_config_item_model_1.OverviewConfigItemModel(3, 6);
            }
            else {
                dummyConfig = new overview_config_item_model_1.OverviewConfigItemModel(3, 1, overview_field_type_1.OverviewPortfolioFieldType.CALCULATION);
            }
            this.itemConfig.contentFieldsWithLevels = dummyConfig.contentFieldsWithLevels;
        }
    };
    OverviewConfigDialogComponent.prototype.changeCardType = function (cardTypeId) {
        if (this.itemConfig.cardType) {
            this.itemConfig.cardType.id = cardTypeId;
        }
        else {
            this.itemConfig.cardType = { id: cardTypeId };
        }
        var category = null;
        if (cardTypeId === overview_card_type_1.OverviewCardType.MAIN_CARD) {
            category = this.rootCategory;
        }
        this.onCardMainCategoryChange(category);
        this.changeAcceptableOverviewFieldTypes();
    };
    OverviewConfigDialogComponent.prototype.changeAcceptableOverviewFieldTypes = function () {
        if (this.itemConfig.cardType) {
            switch (this.itemConfig.cardType.id) {
                case overview_card_type_1.OverviewCardType.CUSTOM_CARD:
                    this.acceptableOverviewFieldTypes = config_constants_1.OVERVIEW_PORTFOLIO_FIELD_TYPES.filter(function (type) { return type.id !== overview_field_type_1.OverviewPortfolioFieldType.FIELD && type.id !== overview_field_type_1.OverviewPortfolioFieldType.AGGREGATE; });
                    break;
                case overview_card_type_1.OverviewCardType.GROUP_CARD:
                    this.acceptableOverviewFieldTypes = config_constants_1.OVERVIEW_PORTFOLIO_FIELD_TYPES.filter(function (type) { return type.id !== overview_field_type_1.OverviewPortfolioFieldType.FIELD; });
                    break;
                default:
                    this.acceptableOverviewFieldTypes = config_constants_1.OVERVIEW_PORTFOLIO_FIELD_TYPES;
            }
        }
    };
    // ToDo: delete after some time - function is for supporting type changes
    OverviewConfigDialogComponent.prototype.eliminateWrongTypeSelection = function () {
        if (this.itemConfig.cardType.id === overview_card_type_1.OverviewCardType.GROUP_CARD
            || this.itemConfig.cardType.id === overview_card_type_1.OverviewCardType.CUSTOM_CARD) {
            this.itemConfig.contentFieldsWithLevels.forEach(function (levelItems) {
                return levelItems.data = levelItems.data.map(function (item) {
                    return !item.overviewPortfolioFieldType || item.overviewPortfolioFieldType !== overview_field_type_1.OverviewPortfolioFieldType.FIELD ?
                        item : new overview_content_field_model_1.OverviewContentPortfolioFieldModel(overview_field_type_1.OverviewPortfolioFieldType.CALCULATION);
                });
            });
        }
    };
    OverviewConfigDialogComponent.prototype.save = function () {
        this.isValidTitle = !!this.itemConfig.title;
        this.isValidType = !!this.itemConfig.cardType && !!this.itemConfig.cardType.id;
        if (this.isValidTitle && this.isValidType) {
            this.dialogRef.close(this.itemConfig);
            this.itemConfig.contentFieldsWithLevels.forEach(function (items) {
                items.hasValue = items.data.findIndex(function (item) { return item.fieldName != null; }) >= 0;
            });
        }
    };
    OverviewConfigDialogComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    OverviewConfigDialogComponent.prototype.onChangeIcon = function (iconId) {
        this.itemConfig.icon = iconId;
    };
    OverviewConfigDialogComponent.prototype.onDimensionsSelect = function (dimension) {
        this.itemConfig.resizeContentFieldsWithLevels(dimension.height, dimension.width, this.itemConfig.cardType.id === overview_card_type_1.OverviewCardType.CUSTOM_CARD
            || this.itemConfig.cardType.id === overview_card_type_1.OverviewCardType.GROUP_CARD ? overview_field_type_1.OverviewPortfolioFieldType.CALCULATION
            : overview_field_type_1.OverviewPortfolioFieldType.FIELD);
    };
    OverviewConfigDialogComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-overview-config-dialog',
            styles: [require('./overview-config-dialog.component.css')],
            template: require('./overview-config-dialog.component.html'),
        }),
        __param(5, core_1.Optional()),
        __param(6, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [summary_page_configs_helper_service_1.SummaryPageConfigsHelperService,
            material_1.MatDialogRef,
            idm_session_data_provider_api_js_1.SessionDataProvider,
            idm_kb_service_client_js_1.KbService,
            material_1.MatDialog,
            overview_custom_calculation_fields_service_1.OverviewCustomCalculationFieldsService, Object])
    ], OverviewConfigDialogComponent);
    return OverviewConfigDialogComponent;
}());
exports.OverviewConfigDialogComponent = OverviewConfigDialogComponent;
//# sourceMappingURL=overview-config-dialog.component.js.map